var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLive4ENevXx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.868,
    height: 54.126,
    viewBox: "0 0 54.868 54.126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.336 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.067,1.5H13.69A5.356,5.356,0,0,0,8.318,6.85V26.667a5.375,5.375,0,0,0,5.372,5.372h8.19L18.585,38.28a2.229,2.229,0,0,0,3.942,2.081l4.394-8.322h1.919l4.394,8.322a2.229,2.229,0,0,0,3.943-2.081l-3.3-6.241h8.185a5.375,5.375,0,0,0,5.372-5.372V6.85A5.356,5.356,0,0,0,42.067,1.5ZM34.572,18.989H21.19a2.229,2.229,0,1,1,0-4.458H34.572a2.229,2.229,0,1,1,0,4.458Z",
    transform: "translate(8.764 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.543,27.319a6.2,6.2,0,1,0-6.212-6.192,6.2,6.2,0,0,0,6.212,6.192Z",
    transform: "translate(3.76 16.839)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.837,20.28a9.52,9.52,0,0,1-15.065,0,13.541,13.541,0,0,0-5.254,6.969A3.574,3.574,0,0,0,2.036,30.5a3.8,3.8,0,0,0,3.022,1.556H23.55a3.721,3.721,0,0,0,3.5-4.984,13.444,13.444,0,0,0-5.21-6.788Z",
    transform: "translate(0 23.574)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive4ENevXx);
export default __webpack_public_path__ + "static/media/live_4eNevXX.1b362f092074a622553c1803cd447fe8.svg";
export { ForwardRef as ReactComponent };